import { TableHead, styled } from '@mui/material'

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  '& tr:first-of-type th': {
    fontSize: '1rem !important',
    fontWeight: 700,
  },
}))
